import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import * as snapSellWizardActions from 'actions/snapSellWizardActions';
import * as countriesActions from 'actions/countriesActions';

import Wizard from 'components/Wizard';
import SnapSellPackagePage from 'containers/SnapSellPackagePage';
import SecureCheckoutPage from 'containers/SecureCheckoutPage';
import FinalSubmissionPage from 'containers/SubmissionSteps/FinalSubmissionPage';
import { trackPageView } from 'lib/eventTracking'

class SnapSellWizardContainer extends Component {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    goToSnapSellStep: PropTypes.func.isRequired,
    currentUser: ImmutablePropTypes.map,
    fetchCountries: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.props.fetchCountries();
  }

  getSteps() {
    const { userLoggedIn } = this.props;
    let steps = [
      {
        name: 'Snap Sell Package',
        component: <SnapSellPackagePage/>,
        accessible: true,
        completed: false
      },
      {
        name: 'Secure Checkout',
        component: <SecureCheckoutPage/>,
        accessible: true,
        completed: false
      },
    ];

    if (!userLoggedIn) {
      steps.splice(1, 0, {
        name: 'Authenticate user',
        component: <FinalSubmissionPage/>,
        accessible: true,
        completed: false,
      });
    }

    return steps;
  }

  changeStep(step) {
    trackPageView(step === (this.getSteps().length - 1) ? 'Snapsell Package' : 'Secure Checkout' );
    return this.props.goToSnapSellStep(step);
  }

  userHasCredits() {
    const { userLoggedIn, currentUser, pricingTierLevel } = this.props;
    if (!userLoggedIn) return;

    const availablePricingTiers = currentUser.get('available_pricing_tiers');

    if (availablePricingTiers) {
      return pricingTierLevel <= availablePricingTiers.max();
    }
  }

  render() {
    const steps = this.getSteps();
    let { currentStep } = this.props;

    if (this.userHasCredits()) {
      this.props.history.push({ pathname: '/basics' });
      return null;
    }

    return (
      <Wizard
        currentStep={currentStep}
        additionalStepProps={{ snapSell: true }}
        steps={steps}
        onStepChange={this.changeStep.bind(this)}
        history={this.props.history}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  currentStep: state.snapSellWizard.get('currentStep'),
  currentUser: state.currentUser.get('data'),
  userLoggedIn: state.currentUser.get('isLoggedIn'),
  pricingTierLevel: state.checkoutData.get('pricing_tier_level'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(snapSellWizardActions, dispatch),
  ...bindActionCreators(countriesActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SnapSellWizardContainer);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SnapSellWizardContainer.jsx